import thumbnail2026 from "../assets/2026-2.png"
import thumbnail2025 from "../assets/2025-2.png"
import thumbnail2024 from "../assets/2024-2.png"
import thumbnail2023 from "../assets/2023-2.png"

export const PastWebsites = () => {
  return (
    <ul className="past-websites">
      <li>
        <a
          href="https://2026.hackatbrown.org/"
          className="underline-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={thumbnail2026}
            alt="Hack@Brown 2026"
            className="past-thumbnail"
          />
        </a>
      </li>
      <li>
        <a
          href="https://2025.hackatbrown.org/"
          className="underline-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={thumbnail2025}
            alt="Hack@Brown 2025"
            className="past-thumbnail"
          />
        </a>
      </li>
      <li>
        <a
          href="https://2024.hackatbrown.org/"
          className="underline-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={thumbnail2024}
            alt="Hack@Brown 2024"
            className="past-thumbnail"
          />
        </a>
      </li>
      <li>
        <a
          href="https://2023.hackatbrown.org/"
          className="underline-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={thumbnail2023}
            alt="Hack@Brown 2023"
            className="past-thumbnail"
          />
        </a>
      </li>
    </ul>
  )
}
